import React, { createContext, useContext, useReducer } from 'react';
import reducer from './reducer';

export const initialState = {
  packSitesState: '',
  packSites: [],
  noMorePacksites: false,
  packDetailFilters: {},
  // eventNotifications: [],
  // readEventNotifications: [],
}

export const packSitesStateContext = createContext();
export const PackSiteDispatchContext = createContext();

function PackSiteContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <packSitesStateContext.Provider value={state}>
      <PackSiteDispatchContext.Provider value={dispatch}>
        {children}
      </PackSiteDispatchContext.Provider>
    </packSitesStateContext.Provider>
  )
}

function usePackSiteDispatch() {
  const context = useContext(PackSiteDispatchContext)
  if (context === undefined) {
    throw new Error('usePackSiteDispatch must be used within a PacksiteProvider')
  }
  return context
}

function usePackSiteState() {
  const context = useContext(packSitesStateContext)
  if (context === undefined) {
    throw new Error('usePackSiteState must be used within a PacksiteProvider')
  }
  return context
}

export { PackSiteContext, usePackSiteDispatch, usePackSiteState };